var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCards({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1462_41942)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.6289,
    cy: 59.3633,
    r: 3.19922,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9688 20.5V57.1256C16.9688 58.4185 16.9688 60.7818 16.9719 62.0006C18.1834 62.0006 20.5508 62.0006 21.8437 62.0006H70.5938C71.2402 62.0006 73.0312 62.0006 73.0312 62.0006C73.0312 60.7818 73.0312 60.2095 73.0312 59.5631V25.4381C73.0312 24.7916 73.0312 23.0006 73.0312 23.0006C73.0312 23.0006 71.2402 23.0006 70.5938 23.0006H67M16.9688 20.5C16.9688 23.5832 19.1885 23.0006 21.8437 23.0006H67M16.9688 20.5C16.9688 17.4168 19.1885 18.0006 21.8437 18.0006H63.2812C67 18.0006 67 20.201 67 23.0006",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 43C57.3284 43 58 42.3284 58 41.5C58 40.6716 57.3284 40 56.5 40C55.6716 40 55 40.6716 55 41.5C55 42.3284 55.6716 43 56.5 43Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 41C51 38.2386 53.2386 36 56 36H73V47H56C53.2386 47 51 44.7614 51 42V41Z",
    stroke: "black",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.9609,
    cy: 68.9609,
    r: 16.3516,
    fill: "#FF4A01",
    stroke: "black",
    strokeWidth: 1.42188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.22 76.0695C70.22 76.6584 69.7425 77.1359 69.1536 77.1359C68.5646 77.1359 68.0872 76.6584 68.0872 76.0695V70.2233H62.2407C61.6518 70.2233 61.1743 69.7458 61.1743 69.1569C61.1743 68.5679 61.6518 68.0905 62.2407 68.0905H68.0872V62.2446C68.0872 61.6557 68.5646 61.1782 69.1536 61.1782C69.7425 61.1782 70.22 61.6557 70.22 62.2446V68.0905H76.0656C76.6545 68.0905 77.132 68.5679 77.132 69.1569C77.132 69.7458 76.6545 70.2233 76.0656 70.2233H70.22V76.0695Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1462_41942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCards);
export default __webpack_public_path__ + "static/media/no-cards.4f54b086ab7be40ece38620dda813748.svg";
export { ForwardRef as ReactComponent };